enum WorkspaceProjectLandUseClosedQuestions {
  'Yes' = 'Yes',
  'No' = 'No',
  'Partially' = 'Partially',
}

export default WorkspaceProjectLandUseClosedQuestions
